<template>
    <Layout>
        <ErrorContent
            :type="type"
            showButtons
        />
    </Layout>
</template>
<script setup lang="ts">
import { useHead } from '@unhead/vue'

import { onMounted, onServerPrefetch, watch } from 'vue'

import ErrorContent from '@/components_new/ErrorContent/ErrorContent.vue'
import { useLocalizedRouters } from '@/composables/localized-routers'
import { useI18nAddon } from '@/i18n/i18n'
import Layout from '@/layouts/ModernTwoColumnsLayout.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { type ErrorStatus } from '@/store/app-store'
import { useGeneralStore } from '@/store/general-store'

const generalStore = useGeneralStore()

defineProps<{
    type: ErrorStatus
}>()

const { getHrefLangs } = useLocalizedRouters()

useHead(() => ({
    link: getHrefLangs({ forRoute: { name: ROUTE_NAMES.MAIN } }),
}))

onServerPrefetch(async () => {
    await generalStore.setMainData()
})

onMounted(async () => {
    await generalStore.setMainData()
})

const { currentLocale } = useI18nAddon()
watch(currentLocale, generalStore.setMainData)
</script>
